import { User } from 'next-firebase-auth';
import { fetcherAndLog } from '@utils/fetcher';
import { userToken } from '@utils/firebase/initAuth';
import { getBaseUrl } from '@utils/general-utils';
import { ExecutableLessonFile } from '@customtypes/parsedLesson';

export type UserReportOption =
  | 'content_wrong_answer'
  | 'content_typo'
  | 'content_confusing'
  | 'app_issue'
  | 'unclear_translation';

export async function postUserReport({
  user,
  tutorialId,
  lessonId,
  report,
}: {
  user: User;
  tutorialId: number;
  lessonId: number;
  report: {
    reportOption: UserReportOption;
    reportText: string;
    tutorialVersion: number;
    interactionType: string;
    userCode?: ExecutableLessonFile[];
  };
}) {
  const token = await userToken(user);
  const url = `${getBaseUrl(
    false,
  )}/tutorials/${tutorialId}/lessons/${lessonId}/report`;
  const body = {
    ...report,
    ...(report.userCode && { userCode: JSON.stringify(report.userCode) }),
  };
  const result = await fetcherAndLog(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(body),
  });

  if (!result.ok) {
    const { message } = await result.json();
    throw new Error(
      `${
        message ? message : 'Something went wrong posting the lesson report.'
      }`,
    );
  }
  return result.json();
}
